import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../lib/UserContext';
import { ROLES } from '../lib/permissions';
import '../css/Ofrendas.css';  // Archivo CSS específico para la página de Ofrendas

function Ofrendas() {
  const [cedula, setCedula] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Hook para la redirección
  const { login } = useUser(); // Obtener la función login del contexto

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.get(`${apiUrl}/Donantes/identificacion/${cedula}`);
      setError('');
      console.info('Datos del usuario desde API:', response.data);
      
      // Obtener el roleId de múltiples posibles propiedades
      const roleId = response.data.roleId || response.data.id_Rol || response.data.Id_Rol;
      
      console.log('roleId detectado:', roleId);
      console.log('ROLES.ADMINISTRADOR:', ROLES.ADMINISTRADOR);
      console.log('ROLES.TESORERO:', ROLES.TESORERO);
      console.log('ROLES.DONANTE:', ROLES.DONANTE);
      
      // Si es Admin o Tesorero, redirigir a Login para contraseña
      if (roleId === ROLES.ADMINISTRADOR || roleId === ROLES.TESORERO) {
        // Guardar temporalmente los datos del usuario para el login
        sessionStorage.setItem('tempUserData', JSON.stringify(response.data));
        navigate('/login');
      } else if (roleId === ROLES.DONANTE) {
        // Donante no necesita contraseña, login directo
        login(response.data);
        navigate('/reporte');
      } else {
        setError('Rol del donante no reconocido.');
      }
    } catch (error) {
      console.error('Error al consultar los datos:', error);
      setError('Número de cédula no válido.');
    }
  };

  return (
    <div className="ofrendas-container">
      <h1 className="ofrendas-title">Beraca Worship</h1>
      <form onSubmit={handleSubmit} className="ofrendas-form">
        <label htmlFor="cedula">Ingrese su número de cédula:</label>
        <input
          type="text"
          id="cedula"
          value={cedula}
          onChange={(e) => setCedula(e.target.value)}
          required
        />
        <button type="submit" className="submit-button">Enviar</button>
      </form>
      
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      {/* Footer */}
      <footer className="footer">
        <p>© 2024 Iglesia - Softmarket. Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}

export default Ofrendas;
